import { render, staticRenderFns } from "./upload-list.vue?vue&type=template&id=74f8d5ec&"
import script from "./upload-list.vue?vue&type=script&lang=js&"
export * from "./upload-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74f8d5ec')) {
      api.createRecord('74f8d5ec', component.options)
    } else {
      api.reload('74f8d5ec', component.options)
    }
    module.hot.accept("./upload-list.vue?vue&type=template&id=74f8d5ec&", function () {
      api.rerender('74f8d5ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/upload/upload-list.vue"
export default component.exports